export const PHASES = ["先導期", "執行期"]; //, "教材套"

export default function SelectPhase(phases, setPhase, children) {
  return (
    <div className="is-flex is-flex-direction-row is-justify-content-center ">
      {phases.map((phase, i) => (
        <button
          className="button is-info is-large mx-2"
          onClick={() => setPhase(phase)}
          key={i}
        >
          {phase}
        </button>
      ))}
      {children}
    </div>
  );
}
